"use strict";

exports.__esModule = true;
exports.DsBadge = void 0;

require("./DsBadge.css");

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DsBadge = function DsBadge(_ref) {
  var children = _ref.children,
      pill = _ref.pill,
      outline = _ref.outline,
      discreet = _ref.discreet,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      size = _ref.size,
      _ref$additionalClassN = _ref.additionalClassNames,
      additionalClassNames = _ref$additionalClassN === void 0 ? '' : _ref$additionalClassN,
      target = _ref.target,
      onMouseOver = _ref.onMouseOver,
      onMouseOut = _ref.onMouseOut,
      onRemove = _ref.onRemove;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut,
    ref: target,
    className: "badge " + (pill ? 'badge-pill' : '') + " \n            " + (discreet ? "badge-discreet-" + color : outline ? "badge-outline-" + color : "badge-" + color) + " \n            " + (size ? "badge-" + size : '') + " " + additionalClassNames,
    children: [onRemove && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      role: "button",
      className: "close-button me-2",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
        className: "icon icon-sm",
        onClick: onRemove,
        children: "close"
      })
    }), children]
  });
};

exports.DsBadge = DsBadge;